"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tagsEnabledQueryKey = exports.default = void 0;
var _core = require("@folio/stripes/core");
var _reactQuery = require("react-query");
var _endpoints = require("../../constants/endpoints");
const tagsEnabledQueryKey = exports.tagsEnabledQueryKey = [_endpoints.MOD_SETTINGS_ENDPOINT, 'query=(module==TAGS and configName==tags_enabled)', 'stripes-kint-components', 'useTagsEnabled'];
const useTagsEnabled = () => {
  const ky = (0, _core.useOkapiKy)();
  const queryObject = (0, _reactQuery.useQuery)(tagsEnabledQueryKey, () => ky.get(`${_endpoints.MOD_SETTINGS_ENDPOINT}?query=(module==TAGS and configName==tags_enabled)`).json());
  const {
    data: {
      configs: {
        0: {
          value
        } = {}
      } = []
    } = {}
  } = queryObject;
  return !value || value === 'true';
};
var _default = exports.default = useTagsEnabled;